import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiPathEnum, AuditEndpointEnum } from '../constants/endpoints.enum';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedResponse } from '../interfaces/api/common.interface';
import {
  Audit,
  UserHistoryFilters,
  UserHistoryResponse,
} from '../interfaces/audit.interface';

type AuditFilterValue = string | number | boolean | null | undefined;
type AuditFilters = Record<string, AuditFilterValue>;

interface AuditSelectOption {
  key: string | number;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  public API_URL = `${environment.API_URL}${ApiPathEnum.Audit}`;

  constructor(private http: HttpClient) {}

  getAllData(
    page: number,
    limit: number,
    filters: AuditFilters = {},
    skipCount = false
  ): Observable<ApiResponse<PaginatedResponse<Audit>>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('includeValues', 'false')
      .set('skipCount', skipCount ? 'true' : 'false');

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value.toString());
      }
    });
    return this.http.get<ApiResponse<PaginatedResponse<Audit>>>(
      `${this.API_URL}${AuditEndpointEnum.GetAuditData}`,
      { params }
    );
  }

  getAuditDetail(
    id: number | string,
    formatValues = false
  ): Observable<ApiResponse<Audit>> {
    const params = new HttpParams().set(
      'formatValues',
      formatValues ? 'true' : 'false'
    );

    return this.http.get<ApiResponse<Audit>>(
      `${this.API_URL}${AuditEndpointEnum.GetAuditDetail}/${id}`,
      { params }
    );
  }
  getAllScripts(): Observable<ApiResponse<AuditSelectOption[]>> {
    return this.http.get<ApiResponse<AuditSelectOption[]>>(
      `${this.API_URL}${AuditEndpointEnum.GetAllScripts}`
    );
  }

  getAllActions(): Observable<ApiResponse<AuditSelectOption[]>> {
    return this.http.get<ApiResponse<AuditSelectOption[]>>(
      `${this.API_URL}${AuditEndpointEnum.GetAllActions}`
    );
  }

  getAllTables(): Observable<ApiResponse<AuditSelectOption[]>> {
    return this.http.get<ApiResponse<AuditSelectOption[]>>(
      `${this.API_URL}${AuditEndpointEnum.GetAllTables}`
    );
  }

  getAllUsers(): Observable<ApiResponse<AuditSelectOption[]>> {
    return this.http.get<ApiResponse<AuditSelectOption[]>>(
      `${this.API_URL}${AuditEndpointEnum.getAllUsers}`
    );
  }

  getUserHistory(
    userType: number,
    userId: number,
    username: string,
    page: number,
    limit: number,
    filters: UserHistoryFilters = {}
  ): Observable<ApiResponse<UserHistoryResponse>> {
    let params = new HttpParams()
      .set('userType', userType.toString())
      .set('userId', userId.toString())
      .set('username', username)
      .set('page', page.toString())
      .set('limit', limit.toString());

    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params = params.set(key, value.toString());
      }
    });

    return this.http.get<ApiResponse<UserHistoryResponse>>(
      `${this.API_URL}${AuditEndpointEnum.GetUserHistory}`,
      { params }
    );
  }
}
